import { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { Chart } from "primereact/chart";
import { ProgressSpinner } from "primereact/progressspinner";
import { getCountries } from "../../api/countryApi";
import { getLanguages } from "../../api/languageApi";
import { getProducts } from "../../api/productApi";
import { getSources } from "../../api/sourceApi";

export default function DashboardHome() {
  const [stats, setStats] = useState({
    countries: 0,
    products: 0,
    languages: 0,
    sources: 0,
  });

  const [translationChartData, setTranslationChartData] = useState(null);
  const [countryChartData, setCountryChartData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchDashboardData = async () => {
      setIsLoading(true);
      try {
        const [countriesRes, languagesRes, productsRes, sourcesRes] =
          await Promise.all([
            getCountries(token),
            getLanguages(token),
            getProducts(token),
            getSources(token),
          ]);

        const countries = Array.isArray(countriesRes.data) ? countriesRes.data : countriesRes.data.data || [];
        const languages = Array.isArray(languagesRes.data) ? languagesRes.data : languagesRes.data.data || [];
        const products = Array.isArray(productsRes.data) ? productsRes.data : productsRes.data.data || [];
        const sources = Array.isArray(sourcesRes.data) ? sourcesRes.data : sourcesRes.data.data || [];

        setStats({
          countries: countries.length,
          products: products.length,
          languages: languages.length,
          sources: sources.length,
        });

        const languageLabels = languages.map((l) => l.name);
        const translationCounts = languages.map((l) => l.translationCount || 0);

        setTranslationChartData({
          labels: languageLabels,
          datasets: [
            {
              label: "Count of Translations",
              backgroundColor: "rgba(54, 162, 235, 0.4)",
              borderColor: "rgba(54, 162, 235, 1)",
              data: translationCounts,
            },
          ],
        });

        const countryLabels = countries.map((c) => c.name);
        const countryLangCounts = countries.map((c) => Array.isArray(c.languages) ? c.languages.length : 0);

        setCountryChartData({
          labels: countryLabels,
          datasets: [
            {
              label: "Languages",
              backgroundColor: [
                "#42A5F5",
                "#66BB6A",
                "#FFA726",
                "#AB47BC",
                "#FF7043",
                "#26A69A",
                "#D4E157",
                "#8D6E63",
              ],
              data: countryLangCounts,
            },
          ],
        });
      } catch (err) {
        console.error("Error fetching dashboard data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDashboardData();
  }, [token]);

  return (
    <div style={{ position: 'relative' }}>
      {isLoading && (
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: 'rgba(255,255,255,0.8)', zIndex: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <ProgressSpinner />
        </div>
      )}
      <h2 className="mb-1 text-3xl font-bold" style={{ color: "#FC5F1CFF" }}>
        DASHBOARD
      </h2>

      <div className="grid p-2">
        {Object.entries(stats).map(([key, value], i) => (
          <div key={i} className="col-6 md:col-3">
            <Card className="shadow-2 text-center p-2" style={{ minHeight: "90px" }}>
              <h3 style={{ margin: 0, fontSize: "1.5rem" }}>{value}</h3>
              <small>{key.charAt(0).toUpperCase() + key.slice(1)}</small>
            </Card>
          </div>
        ))}
      </div>

      <div className="grid p-2">
        <div className="col-12 md:col-6">
          <Card className="shadow-2 p-2" style={{ minHeight: "400px" }}>
            {translationChartData && (
              <Chart
                type="radar"
                data={translationChartData}
                options={{ maintainAspectRatio: false }}
                style={{ height: "300px" }}
              />
            )}
          </Card>
        </div>

        <div className="col-12 md:col-6">
          <Card className="shadow-2 p-2" style={{ minHeight: "400px" }}>
            {countryChartData && (
              <Chart
                type="polarArea"
                data={countryChartData}
                options={{ maintainAspectRatio: false }}
                style={{ height: "300px" }}
              />
            )}
          </Card>
        </div>
      </div>
    </div>
  );
}
